import _ from "lodash";

import { SessionStore } from "../uidispatcherapi/SessionStore";

import * as util from "./util";

import urlTemplateLib from "url-template";
import moment from "moment";

export default {
    buildPath(pathParts: Array<any>): string {
        return _.map(pathParts)
            .map(part => {
                return encodeURIComponent(part);
            })
            .join("/");
    },

    getTimestampForQueryAsObject() {
        return { __t: moment().valueOf() };
    },

    buildQuery(query: { [x: string]: any }): string {
        return _.keys(query)
            .map(key => {
                const value = query[key];
                if (value === undefined || value === null) {
                    return null;
                }
                if (_.isArray(value)) {
                    if (value.length === 0) {
                        return null;
                    }
                    return _.map(value, item => {
                        if (item) {
                            return key + "=" + encodeURIComponent(item);
                        } else {
                            return "";
                        }
                    }).join("&");
                }
                return key + "=" + encodeURIComponent(value);
            })
            .filter(entry => entry !== null)
            .join("&");
    },

    buildRequest(
        vertical: string,
        service: string,
        template: string,
        pathParams: {
            readonly [key: string]: string | number;
        },
        queryParams:
            | {
                  readonly [key: string]: unknown;
              }
            | null
            | undefined,
        manualBaseUrl: string | null
    ) {
        // FIXME(TO): V1 sshould not be hardcoded and come from somewhere else.
        let baseUrl = "".concat("/", vertical, ".", service, ".", "v1");
        if (manualBaseUrl && manualBaseUrl.length > 0) {
            baseUrl = manualBaseUrl;
        }
        const relativePath = urlTemplateLib.parse(template).expand(pathParams);
        const preQuery = queryParams && this.buildQuery(queryParams);
        const query = preQuery ? "?" + preQuery : "";
        return "".concat(baseUrl, relativePath, query);
    },

    /**
     * Tries to get the CallTreeId and client session id from the SessionStore.
     * Otherwise generates its own.
     */
    generateSessionedUuid(): string {
        if (SessionStore.generateSessionedCallTreeIdWithPrefix) {
            return SessionStore.generateSessionedCallTreeIdWithPrefix("BTEX");
        } else {
            return "BTEX-" + util.generateUuid();
        }
    },

    makeCallTreeHeader(): {
        [key: string]: string;
    } {
        return { CallTreeId: this.generateSessionedUuid() };
    }
};
